import React, { useState, useEffect } from "react";
import {
  FaFilter,
  FaCog,
  FaCalendarAlt,
  FaThLarge,
  FaPlus,
  FaEllipsisV,
} from "react-icons/fa";
import axios from "axios";
import { baseurl } from "../Baseurl";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";
import Calander from "../components/Calander";
import { ArrowLeft, ChevronLeft } from "react-feather";
import UserListTask from "../components/UserListTask";
import ProjectDocs from "../components/ProjectDocs";
import { useNavigate } from "react-router-dom";
import Select from "react-select";


export default function ProjectPageCalander() {
  const { id, title } = useParams();

  const navigate = useNavigate();
const [assignees, setAssignees] = useState([]);

  const [kanbanData, setKanbanData] = useState({
    "Not Started Yet": [],
    Open: [],
    "In Progress": [],
    Completed: [],
  });


   const handleAssigneeChange = (selectedOptions) => {
  setNewTask((prev) => ({
    ...prev,
    assignee: selectedOptions.map((opt) => opt.value)
  }));
};

const columnLabels = {
  "Not Started Yet": "Not Started Yet",
  "Open": "In Progress",      // show "In Progress" for "Open"
  "In Progress": "In Review", // show "In Review" for "In Progress"
  "Completed": "Completed",
};

 const [selectedDate, setSelectedDate] = useState(null);
 
   const [newTask, setNewTask] = useState({
     title: "",
     description: "",
     assignee: "",
     status: "Not Started Yet",
     plannedDate: "",
     completionDate: "",
     actualDate: "",
     priority: "Medium",
   });
  const [isEditMode, setIsEditMode] = useState(false);
  const [editTaskId, setEditTaskId] = useState(null);

  const fetchTasks = async () => {
    try {
      const response = await axios.get(
        `${baseurl}getProductTasksByProjectId/${id}`
      );
      const grouped = {
        "Not Started Yet": [],
        Open: [],
        "In Progress": [],
        Completed: [],
      };

      response.data.forEach((task) => {
        const status = task.status || "Not Started Yet";
        grouped[status] = [
          ...grouped[status],
          {
            id: task.id,
            title: task.title,
            description: task.description,
            assignee: task.assignee,
            date: task.planned_date?.split("T")[0] || "",
            plannedDate: task.planned_date,
            completionDate: task.completion_date,
            actualDate: task.actual_date,
            priority: task.priority,
          },
        ];
      });

      setKanbanData(grouped);
    } catch (error) {
      console.error("Error fetching tasks:", error);
      toast.error("Failed to load tasks");
    }
  };

  // Then your useEffect stays like this:
  useEffect(() => {
    fetchTasks();
  }, [id]);

  const handleEdit = (task, column) => {
    setNewTask({
      title: task.title,
      description: task.description,
      assignee: task.assignee,
      status: column,
      plannedDate: task.plannedDate?.split("T")[0] || "",
      completionDate: task.completionDate?.split("T")[0] || "",
      actualDate: task.actualDate?.split("T")[0] || "",
      priority: task.priority || "Medium",
    });
    setIsEditMode(true);
    setEditTaskId(task.id);

    const modalEl = document.getElementById("addTaskModal");
    const modalInstance =
      window.bootstrap?.Modal.getInstance(modalEl) ||
      new window.bootstrap.Modal(modalEl);
    modalInstance.show();
  };

  const handleDelete = async (taskId) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this task?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(`${baseurl}deleteProductTask/${taskId}`);
        toast.success("Task deleted successfully!");

        const updatedData = { ...kanbanData };
        Object.keys(updatedData).forEach((status) => {
          updatedData[status] = updatedData[status].filter(
            (task) => task.id !== taskId
          );
        });
        setKanbanData(updatedData);
      } catch (error) {
        console.error("Error deleting task:", error);
        toast.error("Failed to delete task");
      }
    }
  };



    useEffect(() => {
      const orgId = localStorage.getItem("organization_id");
      if (!orgId) return;
  
      axios.get(`${baseurl}getAssigneesByOrgId/${orgId}`)
        .then((res) => {
          if (res.data.assignees) {
            const options = res.data.assignees.map((user) => ({
              value: user.id,
              label: user.full_name
            }));
            setAssignees(options);
          }
        })
        .catch((err) => {
          console.error("Failed to fetch assignees:", err);
        });
    }, []);
 
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewTask({ ...newTask, [name]: value });
  };

  const handleSaveTask = async () => {
    try {
      if (isEditMode) {
        const payload = {
          id: editTaskId,
          ...newTask,
         plannedDate: newTask.plannedDate instanceof Date ? newTask.plannedDate.toISOString().split("T")[0] : newTask.plannedDate,
completionDate: newTask.completionDate instanceof Date ? newTask.completionDate.toISOString().split("T")[0] : newTask.completionDate,
actualDate: newTask.actualDate instanceof Date ? newTask.actualDate.toISOString().split("T")[0] : newTask.actualDate,

          project_id: id,
          adminID : localStorage.getItem('adminID'),
        };

        console.log("Sending task update payload:", payload); // ✅ Add this line

        await axios.post(`${baseurl}updateProductTask`, payload);
        toast.success("Task updated successfully!");
setTimeout(() => {
  window.location.reload();
}, 1000); // 1000 ms = 1 second
        // Replace task in state
        const updatedData = { ...kanbanData };
        Object.keys(updatedData).forEach((status) => {
          updatedData[status] = updatedData[status].map((task) =>
            task.id === editTaskId ? { ...task, ...newTask } : task
          );
        });
        fetchTasks();
        setKanbanData(updatedData);
      } else {
        await axios.post(`${baseurl}insertProductTask`, {
          ...newTask,
         plannedDate: newTask.plannedDate instanceof Date ? newTask.plannedDate.toISOString().split("T")[0] : newTask.plannedDate,
completionDate: newTask.completionDate instanceof Date ? newTask.completionDate.toISOString().split("T")[0] : newTask.completionDate,
actualDate: newTask.actualDate instanceof Date ? newTask.actualDate.toISOString().split("T")[0] : newTask.actualDate,

          project_id: id,
          adminID : localStorage.getItem('adminID'),
        });
        toast.success("Task added successfully!");
setTimeout(() => {
  window.location.reload();
}, 1000); // 1000 ms = 1 second
        await fetchTasks();
        const updatedData = { ...kanbanData };
        updatedData[newTask.status] = [...updatedData[newTask.status], newTask];
        setKanbanData(updatedData);
      }
    } catch (error) {
      console.error("Error saving task:", error);
      toast.error(isEditMode ? "Failed to update task" : "Failed to add task");
    }

    // Reset
    setNewTask({
      title: "",
      description: "",
      assignee: "",
      status: "Not Started Yet",
      plannedDate: "",
      completionDate: "",
      actualDate: "",
      priority: "Medium",
    });
    setIsEditMode(false);
    setEditTaskId(null);

    const modalEl = document.getElementById("addTaskModal");
    const modalInstance =
      window.bootstrap?.Modal.getInstance(modalEl) ||
      new window.bootstrap.Modal(modalEl);
    modalInstance.hide();
  };



  const unslugify = (slug) =>
  slug
    .replace(/-/g, ' ')                  // Replace dashes with spaces
    .replace(/\b\w/g, (c) => c.toUpperCase()); // Capitalize each word

 
   return (
  <div className="bg-light min-vh-100 ">


    {/* Top Header */}
    <div className="bg-danger text-white d-flex justify-content-between align-items-center p-3 rounded">
      <h4 className="mb-0 fw-bold text-white"> 
      <button
      onClick={() => navigate(-1)}
      className="text-white bg-transparent border-0"
    >
      <ArrowLeft />
    </button>
        
        {unslugify(title)}</h4>
      <div className="d-flex align-items-center gap-2">

        <ProjectDocs projectId = {id}/>

 

        <Link to={`/project-detail/${id}/${title}`} className="btn btn-light btn-sm d-flex align-items-center gap-1">
            <FaThLarge /> Kanban
          </Link>
          <Link to={`/project-detail-calander/${id}/${title}`} className="btn me-5 btn-light btn-sm d-flex align-items-center gap-1">
            <FaCalendarAlt /> Calendar
          </Link>
        {/* <button className="btn btn-link text-white">
          <FaFilter />
        </button>
        <button className="btn btn-link text-white">
          <FaCog />
        </button> */}
        
        <UserListTask id = {id}/>
      </div>
    </div>


<div className="p-3">

{/* Add Task Button */}
      <div className="p-1">
        <button
          className="btn new-project-btn d-flex align-items-center gap-1 px-3 py-2 tab4 mainttl  "
          data-bs-toggle="modal"
          data-bs-target="#addTaskModal"
        >
          <FaPlus /> Add Task
        </button>
      </div>

<div className="row g-2">
    <div className="col-md-4">
        <Calander kanbanData={kanbanData} onDateClick={setSelectedDate} />
      </div>

      <div className="col-md-8">
        <div className="bg-white border rounded shadow-sm p-3 mt-3">
          <h5 className="fw-bold mb-3">Tasks</h5>
          {Object.entries(kanbanData).flatMap(([status, tasks]) =>
            tasks.map((task, i) => {
              const isHighlighted =
                selectedDate &&
                new Date(task.date).toDateString() === new Date(selectedDate).toDateString();

              return (
                <div
                  key={`${status}-${i}`}
                  className={`d-flex justify-content-between border-bottom py-2 ${
                    isHighlighted ? 'bg-danger-custom px-2 bg-opacity-25 rounded' : ''
                  }`}
                >
                  <div>
                    <div className="fw-bold">{task.title}</div>
                    <div className="  small">{task.description}</div>
                  </div>
                  <div className="text-end text-muted small" style={{ minWidth: "75px" }}>
                    {task.date
                      ? new Date(task.date).toLocaleDateString("en-US", {
                          month: "short",
                          day: "numeric",
                        })
                      : ""}
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
</div>
 
</div>





{/* Add Task Modal */}
<div
        className="modal fade"
        id="addTaskModal"
        tabIndex="-1"
        aria-labelledby="addTaskModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addTaskModalLabel">
                {isEditMode ? "Update Task" : "Add Task"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row g-2">
                <div className="col-md-12">
                  <label className="form-label">Title</label>
                  <input
                    type="text"
                    name="title"
                    value={newTask.title}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
                <div className="col-md-12">
                  <label className="form-label">Description</label>
                  <textarea
                    name="description"
                    value={newTask.description}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>

                <div className="col-md-12">
                  <label className="form-label">User / Assignee</label>
                  <Select
                    options={assignees} // should be in format [{ value: id, label: full_name }]
                    isMulti
                    value={assignees.filter((opt) =>
                      newTask.assignee?.includes(opt.value)
                    )} // ✅ pre-select matching options
                    onChange={handleAssigneeChange}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select assignees"
                  />
                </div>

                <div className="col-md-12">
                  <label className="form-label">Status</label>
                  <select
  name="status"
  value={newTask.status}
  onChange={handleInputChange}
  className="form-select"
>
  {Object.keys(kanbanData).map((status) => (
    <option key={status} value={status}>
      {columnLabels[status] || status}
    </option>
  ))}
</select>
                </div>
 
                  

                  {/* <div className="col-md-4">
                    <label className="form-label  w-100">Completion Date</label>
                    <DatePicker
                      selected={newTask.completionDate}
                      onChange={(date) =>
                        setNewTask({ ...newTask, completionDate: date })
                      }
                      className="form-control  w-100"
                      dateFormat="yyyy-MM-dd"
                      placeholderText="Select date"
                    />
                  </div> */}

                  {/* <div className="col-md-4">
                    <label className="form-label  w-100">
                      Actual Completion Date
                    </label>
                    <DatePicker
                      selected={newTask.actualDate}
                      onChange={(date) =>
                        setNewTask({ ...newTask, actualDate: date })
                      }
                      className="form-control  w-100"
                      dateFormat="yyyy-MM-dd"
                      placeholderText="Select date"
                    />
                  </div> */}
                 

                <div className="col-md-4">
                  <label className="form-label">Priority</label>
                  <select
                    name="priority"
                    value={newTask.priority}
                    onChange={handleInputChange}
                    className="form-select"
                  >
                    <option value="Low">Low</option>
                    <option value="Medium">Medium</option>
                    <option value="High">High</option>
                  </select>
                </div>
                <div className="col-md-4">
                    <label className="form-label  w-100">
                      Due Date
                    </label>

                    <DatePicker
                      selected={newTask.plannedDate}
                      onChange={(date) =>
                        setNewTask({ ...newTask, plannedDate: date })
                      }
                      className="form-control  w-100"
                      dateFormat="yyyy-MM-dd"
                      placeholderText="Select date"
                    />
                  </div>

              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSaveTask}
              >
                {isEditMode ? "Update Task" : "Save Task"}
              </button>
            </div>
          </div>
        </div>
      </div>
 
    <ToastContainer
      position="top-center"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      pauseOnFocusLoss={false}
      draggable
      pauseOnHover
      theme="colored"
    />
  </div>
);
}
